import type { FC } from "react";
import { PiSmileySadLight } from "react-icons/pi";
import { Button } from "rsuite";
interface NotFoundProps {}

const NotFound: FC<NotFoundProps> = ({}) => {
  return (
    <div className="not-found">
      <div className="flex flex-col items-center justify-center h-screen">
        <PiSmileySadLight size={160} className="text-gray-500" />
        <h1 className="text-center text-2xl font-semibold uppercase text-red-500">Page not found</h1>
        <p className="text-center text-lg">The page you are looking for does not exist.</p>
        <Button color="cyan" appearance="ghost" className=" mt-4" onClick={() => window.history.back()}>
          Go back
        </Button>
      </div>
    </div>
  );
};
export default NotFound;
